<template>
	<div class="layout-app">
		<!-- 悬浮按钮 -->
		<div v-if="isMinimized" class="minimized-button" @click="restoreDialog">
			<i class="el-icon-message"></i>
		</div>
		<!-- main -->
		<el-dialog :title="nameTitle" :visible.sync="addDialogVisible" width="78%" v-dialogDrag
			:before-close="handleClose" :fullscreen="isFullscreen" :modal="false" :show-close="false"
			:close-on-click-modal="false" custom-class="minimizable-dialog">
			<!-- 在el-dialog的header部分添加自定义内容 -->
			<template slot="title">
				<div class="dialog-header">
					<span>{{ nameTitle }}</span>
					<div class="header-buttons">
						<el-button type="text" size="medium" @click="toggleFullscreen"
							:icon="isFullscreen ? 'el-icon-minimize' : 'el-icon-full-screen'"
							:title="isFullscreen ? '退出全屏' : '全屏显示'">
						</el-button>
						<el-button type="text" size="medium" @click="handleClose" icon="el-icon-close" title="关闭">
						</el-button>
					</div>
				</div>
			</template>
			<!-- 新增 -->
			<div class="addAcc" ref='myBox' v-if="!isMinimized" 
			   v-loading="loading" 
			   element-loading-text="正在加载调拨单数据..." 
			   element-loading-spinner="el-icon-loading"
			   element-loading-background="rgba(0, 0, 0, 0.8)">
				<!-- tabs -->
				<div class="tabs">
					<div class="tabsMain">
						<!-- 表单 header -->
						<div class="headerForm">
							<el-form ref="addForm" :rules="addFormRules" :model="addForm" size="mini"
								label-width="88px">
								<el-row :gutter="40">
									<el-col :xs="val.xs" :sm="val.xs" :md="val.md" :lg="val.lg" :xl="val.xl"
										v-for="(val,i) in formType" :key="i">
										<!-- input -->
										<el-form-item v-if="val.type == 'input'" :label="val.label"
											:prop="val.modelValue">
											<el-input :suffix-icon='val.prefix' v-model="$data.addForm[val.modelValue]"
												:placeholder="val.placeholder" :disabled="val.disabled"></el-input>
										</el-form-item>
										<!-- textarea -->
										<el-form-item v-if="val.type == 'textarea'" :label="val.label"
											:prop="val.modelValue">
											<el-input type="textarea" :rows="2" placeholder="请输入内容"
												v-model="$data.addForm[val.modelValue]"></el-input>
										</el-form-item>
										<!-- select -->
										<el-form-item v-if="val.type == 'select'" :label="val.label"
											:prop="val.modelValue">
											<el-select v-model="$data.addForm[val.modelValue]" filterable
												placeholder="请选择" @focus="sname(val,i)" @change="handleChange"
												:disabled="val.disabled">
												<el-option v-for="item in $data[val.op]" :key="item.id"
													:label="item.label" :value="item.id">
													<span
														style="color: #8492a6; font-size: 12px">{{ item.label }}</span></el-option>
											</el-select>
										</el-form-item>
										<!-- date -->
										<el-form-item v-if="val.type == 'date'" :label="val.label"
											:prop="val.modelValue">
											<el-date-picker :picker-options="pickerOptions"
												:disabled="val.disabled ? true : false" value-format="yyyy-MM-dd"
												type="date" placeholder="选择日期" v-model="$data.addForm[val.modelValue]">
											</el-date-picker>
										</el-form-item>
										<!-- btn -->
										<el-form-item v-if="val.type == 'btn'">
											<el-button type="primary" plain
												@click="clickEvents(val,i)">{{ val.label }}</el-button>
										</el-form-item>
									</el-col>
								</el-row>
							</el-form>
						</div>
						<!-- 表单数据！第二层取addForm下的list -->
						<div class="mainForm">
							<el-form ref="addMainForm" :rules="addMainFormRules" :model="addMainForm" label-width="82px"
								size="mini">
								<el-row :gutter="8">
									<el-col :xs="val.xs" :sm="val.xs" :md="val.md" :lg="val.lg" :xl="val.xl" type="flex"
										v-for="(val,i) in formMainType" :key="i">
										<!-- select one -->
										<el-form-item v-if="val.type == 'selectName'" :label="val.label"
											:prop="val.modelValue">
											<el-select v-model="$data.addMainForm[val.modelValue]"
												:disabled="val.disabled ? disabled : val.disabled" filterable
												@focus="handlefoucs(val,i)" @change="handleChangeDrug"
												:filter-method="searchMethod" :popper-append-to-body="false">
												<el-group>
													<!-- 固定头部 -->
													<div class="select-header" slot="header" style="font-size: 12px;font-weight: bold;display: flex;justify-content: space-around;padding: 8px;text-align: left;
											    position: sticky;top:0;z-index: 10;background-color: #f1f1f1;">
														<span style="text-align:center;">库存序号</span>
														<span>药品名称</span>
														<span>药品规格</span>
														<span>库存数量</span>
														<span>批次号</span>
														<span>生产厂家</span>
													</div>

													<!-- 选项内容 -->
													<el-option v-for="item in filteredNameOption" :key="item.id"
														:label="item.label" :value="item.id" :disabled="item.disabled">
														<div id="optionItem">
															<span
																style="text-align:center;width: 128px;">{{ item.id }}</span>
															<span style="width: 188px;">{{ item.drugName }}</span>
															<el-tooltip class="item" effect="light"
																:content="item.drugSpec" placement="top">
																<span style="width: 188px;">{{ item.drugSpec }}</span>
															</el-tooltip>
															<span style="width: 188px;">{{ item.purcCnt }}</span>
															<span style="width: 128px;">{{ item.manuLotnum }}</span>
															<span style="width: 188px;">{{ item.prodentpName }}</span>
														</div>
													</el-option>
												</el-group>
												</el-option>
											</el-select>
										</el-form-item>
										<!-- select -->
										<el-form-item v-if="val.type == 'select'" :label="val.label"
											:prop="val.modelValue">
											<el-select v-model="$data.addMainForm[val.modelValue]"
												:disabled="val.disabled ? disabled : val.disabled" filterable>
												<el-option v-for="item in $data[val.op]" :key="item.id"
													:label="item.label" :value="item.id">
													<span style="font-size: 12px">{{ item.label }}</span></el-option>
												</el-option>
											</el-select>
										</el-form-item>
										<!-- input 数量 -->
										<el-form-item v-if="val.type == 'inputNum'" :label="val.label"
											:prop="val.modelValue">
											<el-input placeholder="" v-model="$data.addMainForm[val.modelValue]"
												class="input-with-select">
												<el-select v-model="purcType" slot="prepend" @change="SelectedPurcType"
													placeholder="库存类型">
													<el-option label="最小单位" value="1"></el-option>
													<el-option label="包装单位" value="2"></el-option>
												</el-select>
												<span slot="append"
													icon="el-icon-search">{{ purcType == 1 ? minUnt : unt }}</span>
											</el-input>
										</el-form-item>
										<!-- input -->
										<el-form-item v-if="val.type == 'input'" :label="val.label"
											:prop="val.modelValue">
											<el-input :suffix-icon='val.prefix'
												v-model="$data.addMainForm[val.modelValue]"
												:disabled="val.disabled"></el-input>
										</el-form-item>
										<!-- tag -->
										<el-form-item v-if="val.type == 'tag'" style="margin-left: -68px;">
											<el-tag size="small">{{ MarkUp }}</el-tag>
										</el-form-item>
										<!-- textarea -->
										<el-form-item v-if="val.type == 'textarea'" :label="val.label"
											:prop="val.modelValue">
											<el-input type="textarea" :rows="2" placeholder="请输入内容"
												v-model="$data.addMainForm[val.modelValue]"
												:disabled="val.disabled"></el-input>
										</el-form-item>
										<!-- date -->
										<el-form-item v-if="val.type == 'date'" :label="val.label"
											:prop="val.modelValue">
											<el-date-picker class="autoWidth" :picker-options="pickerOptions"
												@focus="dateChoose(i)" type="date" placeholder="选择日期"
												v-model="$data.addMainForm[val.modelValue]">
											</el-date-picker>
										</el-form-item>
										<!-- btn -->
										<el-form-item v-if="val.type == 'btn'">
											<el-button type="primary" plain
												@click="clickEvents(val,i)">{{ val.label }}</el-button>
										</el-form-item>
									</el-col>
								</el-row>
							</el-form>
						</div>
						<!-- table -->
						<div class="table">
						          <el-table :data="tableData" border :style="{ width: tableWidth + 'px' }"
						                   :cell-class-name="tableCellClassName">
						            <el-table-column prop="allotNum" label="申请调拨数量" width="120">
						              <template slot-scope="scope">
						                <el-input-number 
						                  v-if="scope.row.editing"
						                  v-model.number="scope.row.apllyAmt" 
						                  :min="1" 
						                  :max="9999"
						                  size="mini" 
						                  controls-position="right"
						                  @change="handleEditQuantityChange(scope.row)" />
						                <span v-else>{{ scope.row.apllyAmt }}</span>
						              </template>
						            </el-table-column>
								<el-table-column prop="purcType" label="库存类型">
									<template slot-scope="{ row }">
										<span
											:style="{ color: purcTypeColorMap[row.purcType] }">{{ purcTypeMap[row.purcType] || '未知' }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="realPurcCnt" label="库存数量">
									<template slot-scope="{ row }">
										<span>{{ row.realPurcCnt }}</span>
									</template>
								</el-table-column>
								<!-- 字段映射 -->
								<el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type"
									:prop="col.prop" :label="col.name"
									:width="columnWidth(col, tableData)"></el-table-column>
								<!-- fixed -->
								<el-table-column fixed="left" label="行号" width="68" align="center">
									<template slot-scope="scope">
										{{ scope.$index + 1 }}
									</template>
								</el-table-column>
								<!-- edit -->
								<el-table-column fixed="right" label="操作" width="148">
								              <template slot-scope="scope">
								                <div class="editbox" style="text-align: center;">
								                  <template v-if="!scope.row.editing">
								                    <el-button type="primary" @click="startEditing(scope.row)" size="mini">编辑</el-button>
								                    <el-button type="danger" @click="deleteRow(scope.$index)" size="mini">删除</el-button>
								                  </template>
								                  <template v-else>
								                    <el-button type="success" @click="saveEdit(scope.row)" size="mini" 
								                              :loading="scope.row.saving">保存</el-button>
								                    <el-button type="info" @click="cancelEdit(scope.row)" size="mini">取消</el-button>
								                  </template>
								                </div>
								              </template>
								            </el-table-column>
							</el-table>
							<div class="total">
								<span>成本合计：</span><el-input v-model="cbValue" style="width: 88px;" size="mini"
									:disabled='totaldisabled'></el-input>
								<span style="margin-left: 12px;">零售合计：</span><el-input v-model="lsValue"
									style="width: 88px;" size="mini" :disabled='totaldisabled'></el-input>
							</div>
						</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer" v-if="isAdd === true">
					<el-button size="mini" type="info" plain @click="draftSubmit">存为草稿</el-button>
					<el-button size="mini" plain @click="handleClose">关闭</el-button> <!-- 修改这里 -->
				</div>
				<div slot="footer" class="dialog-footer" v-if="isEdit === true">
					<el-button size="mini" type="info" plain @click="draftEditSubmit">草稿保存</el-button>
					<el-button size="mini" plain @click="handleClose">关闭</el-button> <!-- 修改这里 -->
				</div>
			</div>
		</el-dialog>
		<!-- 内层Model -->
		<div class="innerModel">

		</div>

	</div>
</template>

<script>
	// self
	import AccType from './addAllocateType.js'
	import AccMainType from './addAllocateMainType.js'
	import addForm from './addForm.js' //Form表单
	// prop

	// ext
	import {
		getLunar
	} from 'chinese-lunar-calendar'

	// 接口

	import {
		getDrugDetails
	} from "@/api/PSI.js";
	import {
		findAttribute,
		PurctcmtableList,
		getDocMark,
		selectDropDownList,
		Adddpurcallocate,
		editdpurcallocate,
		dpurcallocateJoin,
		getdpurcallocate
	} from "@/api/systemCatalogue/Western.js";
	import {
		selectDrug
	} from "@/api/PSI/shopReturn.js";

	export default {
		components: {

		},
		props: ['parentMethod'],
		data() {
			//表单校验取大于0的数字型数据
			var validatePercentage = (rule, value, callback) => {
				if (value == '') {
					return callback(new Error('不能为空！'));
				} else {
					// 使用正则表达式验证大于 0 的正整数
					const regex = /^[1-9]\d*$/;
					if (!regex.test(value)) {
						return callback(new Error('数量无效！'));
					}
				}
				callback();
			};
			return {
				//str
				// 新增：操作类型和加载状态
				operationType: 'create', // create: 新建, edit: 编辑, generate: 生成
				autoLoadTimer: null,
				isAutoLoading: false,
				tableWidth: '', //右侧表格动态宽度
				value: '',
				getMinMax: 0,
				saleAmt: '', // 销售金额
				packNum: '',
				cbValue: '',
				lsValue: '',
				purcType: '', // 库存类型 = > 判断大小单位 0最小单位,1包装单位
				dialogTitle: '新增西药采购入库',
				unt: '', // 包装单位 （数量：盒？包？g?）
				minUnt: '', // 最小单位 （数量：盒？包？g?）
				inputSearchValue: '',
				nameTitle: '新建调拨单【西药】',
				deptCode: '',
				getLunarDay: '',
				drugName: '',
				appId: '', // * 选择采购计划时的Id
				startDate: '', // * 开始时间
				endDate: '', // * 结束时间
				currentCell: null, // 单元格隐藏
				year: new Date().getFullYear(),
				month: new Date().getMonth() + 1,
				date: new Date().getDate(),
				lunarDate: '', //农历
				// 1 - 3
				firstName: '',
				seconedName: '',
				thirdName: '',
				auditStatus: '5',
				currentRow: null, //单选高亮
				//num
				MarkUp: 0, // 加成率
				KcNum: 0, // 当前库存数量
				pageNum: 1, //当前页currentPage
				pageSize: 99,
				totalSize: 10, //总条数
				//ble
				isAdd: false,
				isEdit: false,
				loading: false,
				disabled: true,
				totaldisabled: true,
				isMinimized: false,
				addghdwDialog: false,
				selectDisabled: true,
				addDialogVisible: false, //新增model
				dialogFormVisible: false,
				innerVisible: false, //内层Model选择采购计划
				// 新增全屏状态
				isFullscreen: false,
				//arr
				formType: [], // 表单头部内容
				formMainType: [], // 表单主体内容
				tableData: [],
				tableRows: [{
						name: "药品名称",
						prop: "drugName"
					}, {
						name: "规格描述",
						prop: "drugSpec"
					},
					{
						name: "成本单价",
						prop: "purcPric"
					}, {
						name: "成本金额",
						prop: "purcAmt"
					},
					{
						name: "零售单价",
						prop: "salePric"
					}, {
						name: "零售金额",
						prop: "saleAmt"
					},
					{
						name: "生产厂家",
						prop: "prodentpName"
					},
					{
						name: "生产批号",
						prop: "manuLotnum"
					},
				],
				innertableData: [], //内层采购计划数据源
				currentObj: {}, //内层采购计划数据源 = > 单击选择
				currentTable: [], //表格单选
				selectOption: [{
					id: 1,
					label: '西药库'
				}], // 库房
				optionks: [{
					id: 3,
					code: '003',
					label: '西药房'
				}],
				ksOption: [], // 科室 收货库房
				kcOptions: [{
					id: 1,
					label: '最小单位',
					value: '最小单位'
				}, {
					id: 2,
					label: '包装单位',
					value: '包装单位'
				}], // 库存类型
				ghdwOption: [],
				// 加成方式
				MarkOption: [{
						id: 1,
						label: '不加成',
						value: '不加成'
					}, {
						id: 2,
						label: '固定加成',
						value: '固定加成'
					},
					{
						id: 3,
						label: '比例加成',
						value: '比例加成'
					}, {
						id: 4,
						label: '手工比例加成',
						value: '手工比例加成'
					}
				],
				invyOption: [], // 库存序号
				// 表单验证规则 header
				addFormRules: {
				  shedId: [{ required: true, message: '出库库房为必填项！', trigger: 'change' }],
				  phayId: [{ required: true, message: '收货库房为必填项！', trigger: 'change' }],
				  // 供货单位验证
				  gysId: [{ required: true, message: '供货单位为必填项！', trigger: 'change' }]
				},
				purcTypeMap: {
					1: '最小单位',
					2: '包装单位',
				},
				purcTypeColorMap: {
					1: '#67C23A',
					2: '#409EFF',
				},
				// 表单验证规则 main
				addMainFormRules: {
					drugId: [{
						required: true,
						message: '请先选择药品信息！',
						trigger: 'change'
					}],
					purcType: [{
						required: true,
						message: '此项为必填项！',
						trigger: 'change'
					}],
					purcCnt: [{
							required: true,
							message: '调拨的数量为必填项！',
							trigger: 'blur'
						},
						// { 
						//   validator: (rule, value, callback) => {
						// 	// 验证是否为非0正整数
						// 	if (!/^[1-9][0-9]*$/.test(value)) {
						// 	  callback(new Error('调拨的数量为非0正整数!'));
						// 	} 
						// 	// 验证是否选择了库存类型
						// 	else if (this.addMainForm.purcType == '') {
						// 	  callback(new Error('请先选择库存类型!'));
						// 	} else {
						// 	  callback();
						// 	}
						//   },
						//   trigger: 'blur'
						// }
					],
				},
				// 单据状态 0 草稿,1 回退提交,2 已提交,3 回退审核,4 已审核,5 已过单,6 已作废'
				statusOption: [{
					id: 0,
					label: '草稿'
				}, {
					id: 1,
					label: '回退提交'
				}, {
					id: 2,
					label: '已提交'
				}, {
					id: 3,
					label: '回退审核'
				}, {
					id: 4,
					label: '已审核'
				}, {
					id: 5,
					label: '已过单'
				}, {
					id: 6,
					label: '已作废'
				}, ],
				sexOptions: [{
					id: 1,
					label: '男',
					value: '男'
				}, {
					id: 2,
					label: '女',
					value: '女'
				}],
				marryiedOptions: [{
					id: 1,
					label: '未婚',
					value: '未婚'
				}, {
					id: 2,
					label: '已婚',
					value: '已婚'
				}, {
					id: 3,
					label: '离异',
					value: '离异'
				}, {
					id: 4,
					label: '丧偶',
					value: '丧偶'
				}, {
					id: 5,
					label: '再婚',
					value: '再婚'
				}],
				nameOption: [],
				
				//obj
				addForm: {}, // form表单 * 
				addMainForm: {}, // form主体表单 * addForm.list
				lists: {},
				options: [],
				ssrOption: [],
				gysOption: [],
				ManufacturerOptions: [],
				//props
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now()
					},
					shortcuts: [{
							text: '今天',
							onClick(picker) {
								picker.$emit('pick', new Date());
							}
						},
						{
							text: '昨天',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24);
								picker.$emit('pick', date);
							}
						},
						{
							text: '一周前',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
								picker.$emit('pick', date);
							}
						},
						{
							text: '最近一个月',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
								picker.$emit('pick', date);
							}
						},
						{
							text: '最近三个月',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 90);
								picker.$emit('pick', date);
							}
						},
						{
							text: '半年前',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 180);
								picker.$emit('pick', date);
							}
						},
						{
							text: '去年',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 360);
								picker.$emit('pick', date);
							}
						},
					]
				},
				manuDatePickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now()
					},
					shortcuts: [{
							text: '今天',
							onClick(picker) {
								picker.$emit('pick', new Date());
							}
						},
						{
							text: '昨天',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24);
								picker.$emit('pick', date);
							}
						},
						{
							text: '一周前',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
								picker.$emit('pick', date);
							}
						},
						{
							text: '最近一个月',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
								picker.$emit('pick', date);
							}
						},
						{
							text: '最近三个月',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 90);
								picker.$emit('pick', date);
							}
						},
						{
							text: '半年前',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 180);
								picker.$emit('pick', date);
							}
						},
						{
							text: '去年',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 360);
								picker.$emit('pick', date);
							}
						},
					]
				},
				expyDatePickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now()
					},
					shortcuts: [{
							text: '三个月后',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() + 3600 * 1000 * 24 * 90);
								picker.$emit('pick', date);
							}
						},
						{
							text: '半年后',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() + 3600 * 1000 * 24 * 180);
								picker.$emit('pick', date);
							}
						},
						{
							text: '明年',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() + 3600 * 1000 * 24 * 360);
								picker.$emit('pick', date);
							}
						},
						{
							text: '后年',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() + 3600 * 1000 * 24 * 720);
								picker.$emit('pick', date);
							}
						},
						{
							text: '三年后',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() + 3600 * 1000 * 24 * 360 * 3);
								picker.$emit('pick', date);
							}
						},
						{
							text: '五年后',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() + 3600 * 1000 * 24 * 360 * 5);
								picker.$emit('pick', date);
							}
						},
						{
							text: '十年后',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() + 3600 * 1000 * 24 * 360 * 10);
								picker.$emit('pick', date);
							}
						},
					]
				},
			}
		},
		// 在data中添加一个计算属性来过滤nameOption
		computed: {
			filteredNameOption() {
				// 获取表格中所有的drugId
				const existingDrugIds = this.tableData.map(item => item.drugId);
				// 过滤掉已经存在于表格中的药品
				return this.nameOption.filter(item => !existingDrugIds.includes(item.id));
			}
		},
		// 新增：监听 visible 属性变化
		watch: {
			visible: {
				immediate: true,
				handler(newVal) {
					if (newVal && this.addDialogVisible !== newVal) {
						this.addDialogVisible = newVal;
						if (newVal) {
							this.$nextTick(() => {
								this.initData(this.selectedRows);
							});
						}
					}
				}
			},
			selectedRows: {
				deep: true,
				handler(newVal) {
					if (newVal && newVal.length > 0 && this.addDialogVisible) {
						this.processSelectedRows(newVal);
					}
				}
			}
		},
		created() {

		},
		mounted() {
			// 获取接口参数
			this.getAddForm();
			this.getProData();
			this.getGys();
			// 获取制单人 => 当前登录用户
			this.addForm.createId = JSON.parse(localStorage.getItem('userInfo')).userId;
			// 获取终端序号 => 当前登录用户
			this.addForm.terminalId = localStorage.getItem('terminalId');
			// 赋值业务日期
			this.addForm.busDate = new Intl.DateTimeFormat('zh-CN').format(new Date()).replace(/\//g, '-');
		},
		methods: {

			// 
			async loadData() {

			},
			/* 入库药品数据源 */
			async getProData() {
				let res = await selectDrug({
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					drugName: this.drugName
				});
				console.log(res,'asnuodjuejnleNR;;K');
				if (res.code === 200) {
					// 按照 drugName 进行排序
					const sortedData = res.data.content.sort((a, b) => {
						// 如果 drugName 相同，可以按照其他字段排序（如 drugId）
						if (a.drugName === b.drugName) {
							return a.drugId - b.drugId;
						}
						// 否则按照 drugName 升序排序
						return a.drugName.localeCompare(b.drugName);
					});

					// 将排序后的数据赋值给 nameOption
					this.nameOption = sortedData.map(obj => ({
						label: obj.drugName,
						...obj
					}));
				} else {
					this.$message.error(res.message);
				}
			},
			/* props => 生产厂家模糊查询 */
			searchMethod(query, option) {
				console.log(query);
				if (query) {
					console.log(query, '再调一次接口查询');
					this.inputSearchValue = query
					this.pageNum = 1
					this.pageSize = 10
					this.drugName = query
					this.getProData();
				} else {
					console.log('buzou');
				}
			},
			async getGys() {
				// 供应商下拉列表
				let rs = await selectDropDownList();
				this.gysOption = rs.data.content.map(obj => {
					// 将 name 替换为 label，并保留其他字段
					return {
						label: obj.supplierName,
						...obj
					};
				});
			},
			// select聚焦
			async handlefoucs(val, i) {
				this.idx = i;
				console.log(i);
				switch (i) {
					case 0: // 药典名称
						// this.getProData();
						break;
				}
			},
			// 表格单选 => getPlan
			handleCurrentTableChange(val) {
				if (val.state != 5) {
					this.setCurrent();
					this.$message({
						type: 'error',
						message: '只能选择已过单数据!'
					});
				} else {
					// 赋id
					this.appId = val.id
					this.currentTable = val
					this.$message({
						type: 'success',
						message: '已选择:' + this.appId + '的采购计划数据'
					});
				}
			},
			// 库存类型选择
			SelectedPurcType(val) {
				this.addMainForm.purcType = val
				console.log(this.addMainForm.purcType, 'this.addMainForm.purcTypethis.addMainForm.purcType');
			},
			// 取消高亮
			setCurrent(row) {
				this.$refs.singleTable.setCurrentRow(row);
			},
			// 表单头部聚焦事件 => addForm
			async sname(val, i) {
				// val.id = i;
				this.idx = i;
				console.log(i);
				// i event
				switch (i) {
					case 3:
						// 科室档案
						let rs = await findAttribute()
						this.ksOption = rs.data.map(obj => {
							// 将 name 替换为 label，并保留其他字段
							return {
								label: obj.deptName,
								...obj
							};
						});
						break;
				}
			},
			// 新增切换全屏方法
			toggleFullscreen() {
				this.isFullscreen = !this.isFullscreen;
			},
			handleInputPacCut(v, i) {
				this.idx = i;
				console.log(i);
				// i event
				switch (i) {
					case 7:
						let purcCntRule = /^[1-9]\d*$/;
						if (!purcCntRule.test(this.addMainForm.purcCnt)) {
							this.$message({
								type: 'error',
								message: '请输入正确的调拨数量，请注意格式!'
							});
						} else {
							this.getMarkUpPric();
							this.getPageListCheck(); // 检测库存是否充足
						}
						break;
				}
			},
			// 新增方法：过滤nameOption，移除已存在的药品
			// 更新filterNameOption方法
			filterNameOption() {
			    const existingDrugIds = this.tableData.map(item => item.drugId);
			    this.nameOption = this.nameOption.map(item => ({
			        ...item,
			        disabled: existingDrugIds.includes(item.id)
			    }));
			},
			
			// 调用接口查询是否可加入
			async isJoined() {
				console.log(this.addMainForm, '点击加入接口');
				console.log(this.addMainForm.drugId, '药品ID');

				// 检查是否已存在相同药品ID
				const exists = this.tableData.some(item => item.drugId === this.addMainForm.drugId);
				if (exists) {
					this.$message.error('该药品已存在于列表中！');
					return;
				}

				try {
					let result = await dpurcallocateJoin({
						allotNum: this.addMainForm.apllyAmt,
						id: this.addMainForm.drugId,
						purcType: this.purcType
					});

					if (result.code === 200) {
						this.loading = true;

						// 处理返回的数据
						const processedData = {
							...result.data, // 展开接口返回的所有数据
							// 确保必要的字段存在
							drugId: result.data.drugId,
							drugName: this.addMainForm.drugName,
							drugSpec: this.addMainForm.drugspec,
							apllyAmt: this.addMainForm.apllyAmt,
							purcCnt: result.data.realPurcCnt || this.addMainForm.purcCnt,
							purcType: result.data.purcType || this.purcType,
							purcPric: result.data.purcPric,
							salePric: result.data.salePric,
							purcAmt: result.data.purcAmt,
							saleAmt: result.data.saleAmt,
							manuLotnum: result.data.manuLotnum,
							manuDate: result.data.manuDate,
							expyDate: result.data.expyDate,
							prodentpName: result.data.prodentpName,
							minUnt: this.minUnt,
							pacUnt: this.unt,
							editing: false
						};

						// 计算金额（如果接口没有返回金额）
						if (!processedData.purcAmt) {
							processedData.purcAmt = processedData.purcPric * processedData.apllyAmt;
						}
						if (!processedData.saleAmt) {
							processedData.saleAmt = processedData.salePric * processedData.apllyAmt;
						}

						// 将数据添加到表格
						this.tableData.push(processedData);

						// 从nameOption中移除已添加的药品
						this.filterNameOption();

						// 计算总金额
						this.calculateTotals();

						console.log('添加成功的数据:', processedData);
						this.$message.success('已添加！');

						// 重置明细表单
						this.$refs['addMainForm'].resetFields();

						// 不再进行循环，直接返回
						return;

					} else {
						this.$message.error(result.message);
					}

				} catch (error) {
					console.error('接口调用失败:', error);
					this.$message.error('网络错误或接口异常');
				} finally {
					this.loading = false;
				}
			},

			// 计算总金额的方法
			calculateTotals() {
				// 计算成本合计和零售合计
				this.cbValue = this.tableData.reduce((sum, item) => {
					const purcAmt = item.purcAmt || (item.purcPric * item.apllyAmt);
					return sum + parseFloat(purcAmt);
				}, 0);

				this.lsValue = this.tableData.reduce((sum, item) => {
					const saleAmt = item.saleAmt || (item.salePric * item.apllyAmt);
					return sum + parseFloat(saleAmt);
				}, 0);

				// 同时更新表单中的总金额
				this.addForm.costAmt = this.cbValue;
				this.addForm.saleAmt = this.lsValue;
			},

			// 修改getTotalAmt方法
			getTotalAmt(reslut) {
				// 使用新的calculateTotals方法
				this.calculateTotals();
			},
			// 循环加入按钮点击事件 clickEvents 方法
			async clickEvents(val, i) {
			    this.idx = i;
			    console.log(val, i, '点击事件处理');
			    switch (i) {
			        case 12: // 加入按钮
			            // 先验证表单
			            this.$refs.addMainForm.validate(async (valid) => {
			                if (valid) {
			                    await this.handleAddDrug();
			                } else {
			                    this.$message.error('请先完善药品信息！');
			                }
			            });
			            break;
			    }
			},
			// 新增：专门处理药品加入逻辑的方法
			async handleAddDrug() {
			    try {
			        // 检查药品是否已存在
			        const exists = this.tableData.some(item => item.drugId === this.addMainForm.drugId);
			        if (exists) {
			            this.$message.error('该药品已存在于列表中！');
			            return;
			        }
			
			        // 验证调拨数量
			        if (!this.addMainForm.apllyAmt || this.addMainForm.apllyAmt <= 0) {
			            this.$message.error('请输入有效的调拨数量！');
			            return;
			        }
			
			        // 调用接口
			        const result = await this.dpurcallocateJoin({
			            allotNum: this.addMainForm.apllyAmt,
			            id: this.addMainForm.drugId,
			            purcType: this.purcType
			        });
			
			        if (result.code === 200) {
			            await this.processJoinResult(result.data);
			        } else {
			            this.$message.error(result.message || '加入失败！');
			        }
			
			    } catch (error) {
			        console.error('加入药品失败:', error);
			        this.$message.error('网络错误或接口异常');
			    }
			},
			// 修改后的 dpurcallocateJoin 方法
			async dpurcallocateJoin(params) {
			  this.loading = true;
			  try {
			    console.log('调用加入接口，参数:', params);
			    
			    const result = await dpurcallocateJoin(params);
			    
			    if (result.code === 200) {
			      return result;
			    } else {
			      this.$message.error(result.message || '接口调用失败');
			      throw new Error(result.message || '接口调用失败');
			    }
			  } catch (error) {
			    console.error('接口调用失败:', error);
			    throw error;
			  } finally {
			    this.loading = false;
			  }
			},
			// 新增：处理接口返回结果
			async processJoinResult(resultData) {
			    this.loading = true;
			    
			    try {
			        // 处理返回的数据
			        const processedData = {
			            ...resultData,
			            drugId: this.addMainForm.drugId,
			            // drugName: this.addMainForm.drugName,
			            drugSpec: this.addMainForm.drugspec,
			            apllyAmt: this.addMainForm.apllyAmt,
			            purcCnt: resultData.realPurcCnt || this.addMainForm.purcCnt,
			            purcType: resultData.purcType || this.purcType,
			            purcPric: resultData.purcPric || this.addMainForm.purcPric,
			            salePric: resultData.salePric || this.addMainForm.salePric,
			            purcAmt: resultData.purcAmt || (resultData.purcPric * this.addMainForm.apllyAmt),
			            saleAmt: resultData.saleAmt || (resultData.salePric * this.addMainForm.apllyAmt),
			            manuLotnum: resultData.manuLotnum || this.addMainForm.manuLotnum,
			            manuDate: resultData.manuDate || this.addMainForm.manuDate,
			            expyDate: resultData.expyDate || this.addMainForm.expyDate,
			            prodentpName: resultData.prodentpName || this.addMainForm.prodentpName,
			            minUnt: this.minUnt,
			            pacUnt: this.unt,
			            editing: false
			        };
			
			        // 验证库存数量
			        if (processedData.apllyAmt > processedData.purcCnt) {
			            this.$message.error('调拨数量不能大于库存数量！');
			            return;
			        }
			
			        // 添加到表格
			        this.tableData.push(processedData);
			
			        // 从可选列表中移除
			        this.filterNameOption();
			
			        // 计算总金额
			        this.calculateTotals();
			
			        // 重置表单
			        this.resetMainForm();
			
			        this.$message.success('药品添加成功！');
			        
			    } catch (error) {
			        console.error('处理加入结果失败:', error);
			        this.$message.error('处理数据失败');
			    } finally {
			        this.loading = false;
			    }
			},
			// 新增：重置明细表单
			resetMainForm() {
			    // 保留必要的字段，重置其他字段
			    this.addMainForm = {
			        ...this.addMainForm,
			        apllyAmt: '',
			        purcCnt: '',
			        purcPric: '',
			        salePric: '',
			        purcAmt: '',
			        saleAmt: ''
			    };
			    
			    // 重置验证状态
			    if (this.$refs.addMainForm) {
			        this.$refs.addMainForm.clearValidate();
			    }
			},
			// 查看单据数据
			watchData() {
				this.$message({
					type: 'waring',
					message: '正在开发中...'
				});
			},
			// 日期选择
			dateChoose(i) {
				console.log(i);
				switch (i) {
					// 生产日期
					case 13:
						this.pickerOptions = this.manuDatePickerOptions
						break;
						// 有效日期
					case 14:
						this.pickerOptions = this.expyDatePickerOptions
						break;
				}
			},
			// 清空表格表单
			clearForms() {
				this.tableData = [];
				this.cbValue = '';
				this.lsValue = '';
				this.$refs['addForm'].resetFields();
			},
			// 开始时间变化值
			// startDateHandle(value){ if (value) {this.startDate = this.formatDate(value)}},
			// 结束时间变化值
			// endDateHandle(value){ if (value) {this.endDate = this.formatDate(value)}},
			// SelectVal to editForm
			handleChange(val) {
				console.log(val);
				if (val) {
					this.disabled = false
				}
				// i event
			},
			// 库存序号判断
			async getPageListCheck() {
				if (this.addMainForm.drugId == '') {
					this.$message({
						type: 'error',
						message: '请先选择正确的药品信息!'
					});
				} else if (this.addMainForm.prodentpNameId == '') {
					this.$message({
						type: 'error',
						message: '关联的厂家序号错误，请重试。'
					});
				} else if (this.addMainForm.purcCnt > this.KcNum) {
					// this.$message({ type: 'error', message: '调拨数量不能大于当前库存数量！【当前库存数量】：'+this.KcNum});
					this.$confirm('调拨数量不能大于【当前库存数量】！', '提示', {
						confirmButtonText: 'OK',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消'
						});
					});
					this.addMainForm.purcCnt = 1;
				}
			},
			// 选择药品
			handleChangeDrug(val) {
				let drugInfos = this.nameOption.find(name => name.id === val)
				console.log(drugInfos, 'drugInfosdrugInfos');
				this.addMainForm.drugName = drugInfos.name // 药品名称
				// this.addMainForm.id = drugInfos.drugId // 药品名称
				// this.addMainForm.drugId = drugInfos.drugId // 库存序号
				this.addMainForm.prodentpName = drugInfos.prodentpName
				this.addMainForm.drugspec = drugInfos.drugSpec // 药品规格
				this.addMainForm.manuLotnum = drugInfos.manuLotnum // 生产批号
				this.packNum = drugInfos.pacCnt // 包装数量
				this.minUnt = drugInfos.dosUnt // 最小单位
				this.unt = this.addMainForm.pacUnt = drugInfos.pacUnt // 包装单位
				this.addMainForm.purcCnt = drugInfos.purcCnt // 库存数量
				this.addMainForm.purcType = this.purcType = String(drugInfos.purcType)
				this.addMainForm.purcPric = drugInfos.purcPric;
				this.addMainForm.purcAmt = drugInfos.purcAmt;

				this.addMainForm.salePric = drugInfos.salePric;
				this.addMainForm.saleAmt = drugInfos.saleAmt;

				this.addMainForm.manuDate = drugInfos.manuDate;
				this.addMainForm.expyDate = drugInfos.expyDate;

			},

			// 草稿保存 = > 只能先保存草稿
			async draftSubmit() {
			      // 触发表单验证
			      this.$refs.addForm.validate(async (valid) => {
			        if (valid) {
			          // 检查明细数据
			          if (!this.tableData || this.tableData.length === 0) {
			            this.$message.error('请至少添加一条调拨明细数据！');
			            return;
			          }
			
			          try {
			            this.loading = true;
			            
			            // 准备符合接口格式的数据
			            const submitData = {
			              costAmt: parseFloat(this.cbValue) || 0,
			              saleAmt: parseFloat(this.lsValue) || 0,
			              invoDate: this.addForm.invoDate ? 
			                new Date(this.addForm.invoDate).toISOString().split('T')[0] : '',
			              phayId: parseInt(this.addForm.phayId) || 0,
			              purcInvoCodg: this.addForm.purcInvoCodg || '',
			              remarks: this.addForm.remarks || '',
			              shedId: parseInt(this.addForm.shedId) || 0,
			              state: 0,
			              detailsVOS: this.tableData.map(item => ({
			                apllyAmt: parseInt(item.apllyAmt) || 0,
			                invyId: parseInt(item.id || item.invyId) || 0,
			                purcType: parseInt(item.purcType) || 0
			              }))
			            };
			
			            console.log('提交数据格式验证:', JSON.stringify(submitData, null, 2));
			
			            // 调用接口
			            const result = await Adddpurcallocate(submitData);
			
			            if (result.code === 200) {
			              this.$message.success(result.message || '调拨单保存成功');
			              
			              // 新增：设置草稿保存标志，避免关闭时提示未保存
			              this.isDraftSaved = true;
			              
			              // 新增：通知父组件调拨单已保存，需要打开调拨单列表
			              this.$emit('draft-saved', {
			                ...submitData,
			                id: result.data?.id
			              });
			              
			              // 关闭对话框
			              this.handleClose();
			            } else {
			              this.$message.error(result.message || '保存失败');
			            }
			          } catch (error) {
			            console.error('保存调拨单失败:', error);
			            this.$message.error('保存过程中发生错误: ' + error.message);
			          } finally {
			            this.loading = false;
			          }
			        } else {
			          this.$message.error('请完善表单信息！');
			        }
			      });
			    },

			// 草稿修改保存
			async draftEditSubmit() {
			  this.$refs.addForm.validate(async (valid) => {
			    if (valid) {
			      if (!this.tableData || this.tableData.length === 0) {
			        this.$message.error('请至少添加一条调拨明细数据！');
			        return;
			      }
			
			      try {
			        this.loading = true;
			        
			        // 准备编辑数据 - 按照指定格式
			        const submitData = {
			          id: this.addForm.id, // 编辑时需要传递ID
			          costAmt: this.cbValue || 0,
			          saleAmt: this.lsValue || 0,
			          invoDate: this.addForm.invoDate || '',
			          phayId: this.addForm.phayId || 0,
			          purcInvoCodg: this.addForm.purcInvoCodg || '',
			          remarks: this.addForm.remarks || '',
			          shedId: this.addForm.shedId || 0,
			          state: 0, // 草稿状态
			          detailsVOS: this.formatDetailsVOS()
			        };
			
			        const result = await editdpurcallocate(submitData);
			
			        if (result.code === 200) {
			          this.$message.success(result.message || '修改成功');
			          // 新增：通知父组件更新
						this.$emit('update-success', submitData);
			          this.handleClose();
			        } else {
			          this.$message.error(result.message || '修改失败');
			        }
			      } catch (error) {
			        console.error('修改失败:', error);
			        this.$message.error('修改过程中发生错误');
			      } finally {
			        this.loading = false;
			      }
			    }
			  });
			},
			// 新增：打开编辑模式
			  async openForEdit(row) {
			    console.log('打开编辑模式，数据:', row);
			    this.nameTitle = `修改调拨单【${this.getWarehouseType()}】`;
			    this.addDialogVisible = true;
			    this.isAdd = false;
			    this.isEdit = true;
			
			    // 重置表单
			    this.resetForms();
			
			    try {
			      // 加载调拨单详情数据
			      await this.loadTransferDetail(row.id);
			      this.$message.success('调拨单数据加载成功');
			    } catch (error) {
			      console.error('加载调拨单详情失败:', error);
			      this.$message.error('加载调拨单数据失败');
			    }
			  },
			
			  // 新增：加载调拨单详情
			  async loadTransferDetail(id) {
			    try {
			      const response = await getdpurcallocate({ id: id });
			      if (response.code === 200 && response.data) {
			        // 处理返回的数据格式
			        this.fillFormData(response.data);
			      } else {
			        throw new Error(response.message || '获取调拨单详情失败');
			      }
			    } catch (error) {
			      throw error;
			    }
			  },
			
			  // 新增：填充表单数据
			  fillFormData(data) {
			    // 填充主表单数据
			    this.addForm = {
			      id: data.id,
			      shedId: data.shedId,
			      phayId: data.phayId,
			      busDate: data.busDate,
			      purcInvoCodg: data.purcInvoCodg || '',
			      remarks: data.remarks || '',
			      costAmt: data.costAmt || 0,
			      saleAmt: data.saleAmt || 0
			    };
			
			    // 填充表格数据
			    if (data.details && Array.isArray(data.details)) {
			      this.tableData = data.details.map(item => ({
			        ...item,
			        editing: false,
			        originalData: null
			      }));
			    }
			
			    // 计算总金额
			    this.calculateTotals();
			  },
			
			async open(selectedRows = null, operationType = 'create') {
			  console.log('打开调拨单对话框，操作类型:', operationType, '数据:', selectedRows);
			  
			  this.operationType = operationType;
			  this.nameTitle = this.getDialogTitle(operationType);
			  this.addDialogVisible = true;
			  this.isAdd = true;
			  this.isEdit = false;
			
			  // 重置表单
			  this.resetForms();
			
			  try {
			    // 设置默认值
			    await this.setDefaultValues();
			    
			    // 根据操作类型处理数据
			    if (operationType === 'generate' && selectedRows && selectedRows.length > 0) {
			      await this.handleGenerateOperation(selectedRows);
			    } else if (selectedRows && selectedRows.length > 0) {
			      await this.processSelectedRows(selectedRows);
			    } else {
			      await this.loadNecessaryData();
			    }
			
			    this.$message.success(this.getSuccessMessage(operationType));
			
			  } catch (error) {
			    console.error('打开调拨单对话框失败:', error);
			    this.$message.error('打开调拨单对话框失败');
			  }
			},
			
			// 新增：处理生成调拨单操作
			async handleGenerateOperation(rows) {
			  this.loading = true;
			  
			  try {
			    // 处理选中的数据
			    await this.processGenerateRows(rows);
			    
			    // 自动调用加入接口
			    await this.autoJoinDrugs();
			
			  } catch (error) {
			    console.error('生成调拨单操作失败:', error);
			    this.$message.error('生成调拨单失败');
			  } finally {
			    this.loading = false;
			  }
			},
			
			// 新增：处理生成调拨单的行数据
			async processGenerateRows(rows) {
			  try {
			    this.tableData = [];
			
			    for (const row of rows) {
			      // 获取药品详情 - 调用 getDrugDetails 接口
			      const response = await this.getDrugDetails({ id: row.id });
			      if (response.code === 200 && response.data && response.data.list) {
			        response.data.list.forEach(item => {
			          this.tableData.push({
			            ...item,
			            drugId: item.drugId,
			            drugName: item.drugName,
			            drugSpec: item.drugSpecifications,
			            apllyAmt: item.purcCnt, // 默认使用全部数量
			            purcCnt: item.purcCnt,
			            purcType: item.purcType,
			            purcPric: item.purcPric,
			            salePric: item.salePric,
			            purcAmt: item.purcAmt,
			            saleAmt: item.saleAmt,
			            manuLotnum: item.manuLotnum,
			            manuDate: item.manuDate,
			            expyDate: item.expyDate,
			            minUnt: item.minUnt || '粒',
			            pacUnt: item.unt || '盒',
			            editing: false,
			            saving: false,
			            // 保存 invyId 用于后续调用接口
			            invyId: item.id || item.invyId
			          });
			        });
			      }
			    }
			
			    this.calculateTotals();
			
			  } catch (error) {
			    console.error('处理生成调拨单行数据失败:', error);
			    throw error;
			  }
			},
			
			// 新增：自动加入药品（调用 dpurcallocateJoin 接口）
			async autoJoinDrugs() {
			  if (!this.tableData || this.tableData.length === 0) {
			    this.$message.warning('没有可自动加入的药品数据');
			    return;
			  }
			
			  const successItems = [];
			  const failedItems = [];
			
			  for (const item of this.tableData) {
			    try {
			      // 使用 invyId 作为 id 参数调用 dpurcallocateJoin 接口
			      const result = await this.dpurcallocateJoin({
			        allotNum: item.apllyAmt || item.purcCnt,
			        id: item.invyId, // 使用 invyId
			        purcType: item.purcType
			      });
			
			      if (result.code === 200) {
			        // 更新表格数据
			        Object.assign(item, this.processJoinResultData(result.data, item));
			        successItems.push(item.drugName);
			      } else {
			        failedItems.push(`${item.drugName}: ${result.message}`);
			      }
			    } catch (error) {
			      failedItems.push(`${item.drugName}: 接口调用失败`);
			    }
			  }
			
			  // 显示结果
			  if (successItems.length > 0) {
			    this.$message.success(`成功加入 ${successItems.length} 个药品`);
			  }
			  if (failedItems.length > 0) {
			    this.$message.error(`失败 ${failedItems.length} 个药品: ${failedItems.join('; ')}`);
			  }
			
			  // 重新计算总金额
			  this.calculateTotals();
			},
			
			// 新增：处理加入接口返回的数据
			processJoinResultData(resultData, originalItem) {
			  return {
			    purcCnt: resultData.realPurcCnt || originalItem.purcCnt,
			    purcType: resultData.purcType || originalItem.purcType,
			    purcPric: resultData.purcPric || originalItem.purcPric,
			    salePric: resultData.salePric || originalItem.salePric,
			    purcAmt: resultData.purcAmt || (resultData.purcPric * originalItem.apllyAmt),
			    saleAmt: resultData.saleAmt || (resultData.salePric * originalItem.apllyAmt),
			    manuLotnum: resultData.manuLotnum || originalItem.manuLotnum,
			    manuDate: resultData.manuDate || originalItem.manuDate,
			    expyDate: resultData.expyDate || originalItem.expyDate,
			    prodentpName: resultData.prodentpName || originalItem.prodentpName,
			  };
			},
			
			// 新增：获取药品详情接口封装
			async getDrugDetails(params) {
			  try {
			    const response = await getDrugDetails(params);
			    return response;
			  } catch (error) {
			    console.error('获取药品详情失败:', error);
			    throw error;
			  }
			},
			    // 新增：设置默认值
			    async setDefaultValues() {
			      // 出库库房默认1（西药库）
			      this.addForm.shedId = 1;
			      
			      // 收货库房默认3（西药房）
			      this.addForm.phayId = 3;
			      
			      // 设置业务日期
			      this.addForm.busDate = new Intl.DateTimeFormat('zh-CN').format(new Date()).replace(/\//g, '-');
			    },
				
					
			    // 新增：开始自动加载计时器
			    startAutoLoadTimer() {
			      this.autoLoadTimer = setTimeout(() => {
			        if (this.isAutoLoading) {
			          this.$message.info('数据加载中，请稍候...');
			        }
			      }, 2000);
			    },
			
			    // 新增：停止自动加载计时器
			    stopAutoLoadTimer() {
			      if (this.autoLoadTimer) {
			        clearTimeout(this.autoLoadTimer);
			        this.autoLoadTimer = null;
			      }
			    },
			
			// 新增：获取药库类型
			  getWarehouseType() {
			    return this.warehouse = '西药';
			  },
			  
			// 新增：专门用于处理打开的方法，保持与父组件的一致性
			async openDialog(selectedRows = null) {
				return this.open(selectedRows);
			},

			// 新增：初始化数据方法
			async initData(selectedRows = []) {
				try {
					if (selectedRows && selectedRows.length > 0) {
						this.selectedRows = selectedRows;
						await this.processSelectedRows(selectedRows);
					}

					// 加载必要的选项数据
					await this.loadNecessaryData();

				} catch (error) {
					console.error('初始化数据失败:', error);
				}
			},

			// 新增：处理选中的行数据
			async processSelectedRows(rows) {
			      try {
			        this.tableData = [];
			
			        for (const row of rows) {
			          // 获取药品详情
			          const response = await this.getDrugDetails({ id: row.id });
			          if (response.code === 200 && response.data && response.data.list) {
			            response.data.list.forEach(item => {
			              this.tableData.push({
			                ...item,
			                drugId: item.drugId,
			                drugName: item.drugName,
			                drugSpec: item.drugSpecifications,
			                apllyAmt: item.purcCnt, // 默认使用全部数量
			                purcCnt: item.purcCnt,
			                purcType: item.purcType,
			                purcPric: item.purcPric,
			                salePric: item.salePric,
			                purcAmt: item.purcAmt,
			                saleAmt: item.saleAmt,
			                manuLotnum: item.manuLotnum,
			                manuDate: item.manuDate,
			                expyDate: item.expyDate,
			                minUnt: item.minUnt || '粒',
			                pacUnt: item.unt || '盒',
			                editing: false,
			                saving: false
			              });
			            });
			          }
			        }
			
			        this.calculateTotals();
			
			      } catch (error) {
			        console.error('处理选中行数据失败:', error);
			        throw error;
			      }
			    },

			// 新增：加载必要数据
			async loadNecessaryData() {
				try {
					// 加载药品数据
					await this.getProData();
					// 加载供应商数据
					await this.getGys();
					// 加载其他必要数据...
				} catch (error) {
					console.error('加载必要数据失败:', error);
				}
			},

			// 启用编辑状态
			startEditing(row) {
				// 保存原始数据
				row.originalData = JSON.parse(JSON.stringify(row));
				// 设置编辑状态
				this.$set(row, 'editing', true);
			},

			// 取消编辑
			cancelEdit(row) {
				// 恢复原始数据
				if (row.originalData) {
					Object.assign(row, row.originalData);
				}
				// 取消编辑状态
				this.$set(row, 'editing', false);
				delete row.originalData;
			},

			// 保存编辑
			async saveEdit(row) {
			      if (!row.apllyAmt || row.apllyAmt <= 0) {
			        this.$message.error('请输入有效的调拨数量！');
			        return;
			      }
			
			      if (row.apllyAmt > row.purcCnt) {
			        this.$message.error('修改后的数量不能大于库存数量！');
			        return;
			      }
			
			      row.saving = true;
			
			      try {
			        // 调用编辑接口
			        const result = await this.dpurcallocateJoin({
			          allotNum: row.apllyAmt,
			          id: row.drugId,
			          purcType: row.purcType
			        });
			
			        if (result.code === 200) {
			          // 更新行数据
			          Object.assign(row, this.processJoinResultData(result.data, row));
			          
			          // 取消编辑状态
			          row.editing = false;
			          delete row.originalData;
			
			          // 重新计算总金额
			          this.calculateTotals();
			
			          this.$message.success('保存成功！');
			        } else {
			          this.$message.error(result.message || '保存失败！');
			        }
			      } catch (error) {
			        console.error('保存失败:', error);
			        this.$message.error('保存失败：' + (error.message || '未知错误'));
			      } finally {
			        row.saving = false;
			      }
			    },
			
			// 新增：编辑数量变化处理
			    handleEditQuantityChange(row) {
			      // 实时计算金额
			      row.purcAmt = (row.purcPric * row.apllyAmt).toFixed(2);
			      row.saleAmt = (row.salePric * row.apllyAmt).toFixed(2);
			      this.calculateTotals();
			    },
			
			    // 新增：获取对话框标题
			    getDialogTitle(operationType) {
			      const warehouseType = this.getWarehouseType();
			      const titleMap = {
			        'create': `新建调拨单【${warehouseType}】`,
			        'edit': `修改调拨单【${warehouseType}】`,
			        'generate': `生成调拨单【${warehouseType}】`
			      };
			      return titleMap[operationType] || titleMap['create'];
			    },
			
			    // 新增：获取成功消息
			    getSuccessMessage(operationType) {
			      const messageMap = {
			        'create': '调拨单对话框已打开，请添加调拨药品',
			        'edit': '调拨单数据加载成功',
			        'generate': '调拨单生成中，请稍候...'
			      };
			      return messageMap[operationType] || messageMap['create'];
			    },


			// 处理输入变化
			handleInputChange(row) {
				// 重新计算总金额
				this.cbValue = this.addForm.costAmt = row.purcAmt = row.purcPric * row.apllyAmt;
				this.lsValue = this.addForm.saleAmt = row.saleAmt = row.salePric * row.apllyAmt;
				this.calculateTotals();
			},

			// 计算总金额
			// calculateTotals() {
			//   this.cbValue = this.tableData.reduce((sum, item) => {
			//     return sum + (parseFloat(item.purcPric) * parseInt(item.apllyAmt));
			//   }, 0).toFixed(2);

			//   this.lsValue = this.tableData.reduce((sum, item) => {
			//     return sum + (parseFloat(item.salePric) * parseInt(item.apllyAmt));
			//   }, 0).toFixed(2);

			//   // 更新表单中的总金额
			//   this.addForm.costAmt = this.cbValue;
			//   this.addForm.saleAmt = this.lsValue;
			// },
			// 处理输入变化
			// handleInputChange(row) {
			//   // 重新计算总金额
			//   this.cbValue = this.addForm.costAmt = row.purcAmt = row.purcPric * row.purcCnt;
			//   this.lsValue = this.addForm.saleAmt = row.saleAmt = row.salePric * row.purcCnt;
			//   // this.getTotalAmt();
			//    // 重新计算总金额
			//     this.calculateTotals();
			// },
			// 修改回显数据
			async getEdit(parm) {

			},
			// 根据选择的id去查找id对应的对象
			foundObj() {
				let rs = this.gysOption.find(name => name.id === val)
			},
			deleteRow(index) {
			    // 确认删除操作
			    this.$confirm('确定要删除这条药品记录吗？', '提示', {
			        confirmButtonText: '确定',
			        cancelButtonText: '取消',
			        type: 'warning'
			    }).then(() => {
			        // 获取要删除的药品信息（用于后续恢复可选状态）
			        const deletedItem = this.tableData[index];
			        
			        // 从表格数据中删除
			        this.tableData.splice(index, 1);
			        
			        // 重新计算总金额
			        this.calculateTotals();
			        
			        // 如果删除了药品，将该药品重新设为可选
			        if (deletedItem && deletedItem.drugId) {
			            const drugIndex = this.nameOption.findIndex(item => item.id === deletedItem.drugId);
			            if (drugIndex !== -1) {
			                this.$set(this.nameOption[drugIndex], 'disabled', false);
			            }
			        }
			        
			        this.$message.success('删除成功');
			    }).catch(() => {
			        this.$message.info('已取消删除');
			    });
			},
			handleSelectCost(val) {
				this.addForm.nativePlace = val.join(',')
			},
			// db events
			// 给单元格绑定横向和竖向的index，这样就能确定是哪一个单元格
			tableCellClassName({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				row.index = rowIndex;
				column.index = columnIndex;
			},
			// 当input失去焦点的时候，隐藏input
			hideInput() {
				this.currentCell = null;
			},
			// 获得当前双击的单元格的横竖index，然后拼接成一个唯一字符串用于判断，并赋给currentCell  // 拼接后类似这样："1,0","1,1",
			dbclick(row, column) {
				console.log(column.index);
			},
			// db events
			handledbRow(row, column, event) {
				if (row) {
					this.addForm = row;
					this.watchDialogVisible = true
				} else {
					console.log('fail');
				}
				// console.log(this.addForm);
				this.formdisabled = true
			},
			// col 里面包含了表头字段和名称，list 是表格数据
			columnWidth(col, list) {
				let prop = col.prop,
					lab = col.lab;
				let width = 40; // 设定一个最小值
				let maxlenStr = ""; // 最长字符串
				for (let info of list) {
					if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop]
				}
				width = Math.max(width, len(lab), len(maxlenStr));
				// 表格自带的内边距(20px) 自调
				return width + 24; // 这里加了 12px
				function len(str) {
					// 实际分配长度可根据需要自行调整
					let length = 12;
					for (const char of str + "") {
						// 英文小写字符 8px
						if ("a" <= char && char <= "z") length += 8;
						// 英文大写字符 8px
						else if ("A" <= char && char <= "Z") length += 8;
						// 中文字符 28px
						else if (char >= "\u4e00" && char <= "\u9fa5") length += 28;
						// 其他 8px
						else length += 12;
					}
					return length;
				}
			},
			// 内层
			innerColumnWidth(col, list) {
				let prop = col.prop,
					lab = col.lab;
				let width = 28; // 设定一个最小值
				let maxlenStr = ""; // 最长字符串
				for (let info of list) {
					if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop]
				}
				width = Math.max(width, len(lab), len(maxlenStr));
				// 表格自带的内边距(20px) 自调
				return width + 24; // 这里加了 12px
				function len(str) {
					// 实际分配长度可根据需要自行调整
					let length = 12;
					for (const char of str + "") {
						// 英文小写字符 8px
						if ("a" <= char && char <= "z") length += 8;
						// 英文大写字符 8px
						else if ("A" <= char && char <= "Z") length += 8;
						// 中文字符 22px
						else if (char >= "\u4e00" && char <= "\u9fa5") length += 22;
						// 其他 8px
						else length += 12;
					}
					return length;
				}
			},
			// 挂载或销毁前后重新赋值后端参数
			getAddForm() {
				// 左侧提交表单
				this.addForm = addForm.map(v => {
					return v
				})[0]; // Form
				this.addMainForm = this.addForm.detailsVOS[0];
				// 定义数据来源
				this.formType = AccType.map(function(val) {
					return val
				})
				this.formMainType = AccMainType.map(function(val) {
					return val
				})
				console.log(this.addForm, '原始的接口参数数据');
				// 解构赋值排除 list 属性 => 弃用
				// this.addHeadrForm = addForm.map(item => { let { list, ...newItem } = item; return newItem })[0];
			},

			// 重置所有表单和数据
			resetForms() {
				// 重置主表单
				if (this.$refs.addForm) {
					// 重新初始化表单数据
					this.addForm = {
						...addForm.map(v => v)[0], // 从addForm.js重新获取初始数据
						createId: JSON.parse(localStorage.getItem('userInfo')).userId, // 保留制单人
						terminalId: localStorage.getItem('terminalId'), // 保留终端序号
						busDate: new Intl.DateTimeFormat('zh-CN').format(new Date()).replace(/\//g, '-') // 保留业务日期
					};
					this.$refs.addForm.resetFields();
				}

				// 重置明细表单
				if (this.$refs.addMainForm) {
					this.addMainForm = {};
					this.$refs.addMainForm.resetFields();
				}

				// 清空表格数据
				this.tableData = [];

				// 重置金额合计
				this.cbValue = '';
				this.lsValue = '';

				// 重置库存类型
				this.purcType = '';

				// 重置其他状态
				this.loading = false;
			},

			//分页 /每页条数改变触发
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.pageNum = val;
				this.loadData();
			},
			//当前条数改变触发
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageNum = val;
				this.loadData();
			},

			// 打开最小化未保存清空的表单
			restoreDialog() {
				this.addDialogVisible = true;
				this.isMinimized = false;
			},

			// 关闭对话框方法
			handleClose(done) {
			      // 新增：检查是否是草稿保存后关闭，如果是则不提示
			      if (this.isDraftSaved) {
			        this.resetForms();
			        if (typeof done === 'function') {
			          done();
			        } else {
			          this.addDialogVisible = false;
			        }
			        this.$emit('close');
			        // 重置草稿保存标志
			        this.isDraftSaved = false;
			        return;
			      }
			      
			      // 原有逻辑：检查是否有未保存的数据
			      const hasUnsavedChanges = this.checkUnsavedChanges();
			      
			      if (hasUnsavedChanges) {
			        this.$confirm('有未保存的更改，确定要关闭吗？', '提示', {
			          type: 'warning'
			        }).then(() => {
			          this.resetForms();
			          if (typeof done === 'function') {
			            done();
			          } else {
			            this.addDialogVisible = false;
			          }
			          this.$emit('close');
			        }).catch(() => {
			          // 取消关闭
			        });
			      } else {
			        this.resetForms();
			        if (typeof done === 'function') {
			          done();
			        } else {
			          this.addDialogVisible = false;
			        }
			        this.$emit('close');
			      }
			    },
			
			// 新增：重置草稿保存标志的方法
			    resetDraftFlag() {
			      this.isDraftSaved = false;
			    },
			// 新增：检查未保存的更改
			checkUnsavedChanges() {
			  return this.tableData.length > 0 || 
			         Object.keys(this.addForm).some(key => 
			           this.addForm[key] !== '' && 
			           this.addForm[key] !== null && 
			           this.addForm[key] !== undefined
			         );
			}
		},

	}
</script>

<style lang="less" scoped>
	.dialog-header {
		display: flex;
		// height: 28px;
		justify-content: space-between;
		align-items: center;
		width: 100%;

		span {
			color: #fff;
			font-size: 12px;
		}

		.header-buttons {
			display: flex;
			align-items: center;

			/deep/ .el-button {
				padding: 0;
				margin-left: 8px;
				color: #fff;

				&:hover {
					color: #409EFF;
					background-color: transparent;
				}
			}
		}
	}

	#optionItem {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		text-align: left;
		justify-content: space-around;

		span {
			padding-left: 8px;
			border: 1px solid #f1f1f1;
			display: inline-block;
			width: 128px;
			font-size: 12px;
			// height: 26px;
			// line-height: 26px;
			white-space: nowrap;
			/* 禁止换行 */
			overflow: hidden;
			/* 隐藏溢出内容 */
			text-overflow: ellipsis;
			/* 溢出显示省略号 */
		}
	}

	.layout-app {
		width: 100%;
		height: 100%;
		display: flex;
		background-color: f8f8f8;

		/deep/ .el-dialog__header {
			padding: 8px;
			// height: 8px;
			// line-height: 8px;
			background-color: #007bb0;
		}

		/deep/ .el-input--mini .el-input__icon {
			line-height: 0;
		}

		/deep/ .el-dialog__title {
			color: #fff;
			font-size: 12px;
			// line-height: 8px;
		}

		/deep/ .el-dialog__headerbtn .el-dialog__close {
			position: absolute;
			top: -5px;
			right: 2px;
			color: #fff;
		}

		/deep/ .el-dialog__body {
			padding: 10px 20px;
			color: #606266;
			font-size: 14px;
			word-break: break-all;
		}

		/deep/ .el-table .cell {
			font-size: 12px;
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
		}

		/deep/ .el-table th {
			background-color: #f1f1f1;
			border: none;
			color: #2d2d2d;
		}

		.addAcc {

			// self
			// 选项卡
			/deep/ .el-dialog__header {
				padding: 12px;
				background-color: #007bb0;
				// height: 12px;
			}

			/deep/ .el-dialog__title {
				font-size: 12px;
				color: #fff;
			}

			/deep/ .el-dialog__headerbtn .el-dialog__close {
				color: #fff;
			}

			/deep/ .el-dialog__headerbtn {
				top: 10px;
			}

			/deep/ .el-form-item--mini.el-form-item,
			.el-form-item--small.el-form-item {
				margin-bottom: 6px;
			}

			/deep/ .el-dialog__headerbtn .el-dialog__close:hover {
				background-color: brown;
			}

			.tabs {
				.tabsMain {
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					align-items: center;
					width: 100%;

					.table {
						width: 100%;
						margin-top: 12px;
					}

					.total {
						display: flex;
						height: 48px;
						align-items: center;

						span {
							font-size: 12px;
						}
					}

					// 第一层头部表单
					.headerForm {
						/deep/ .el-select>.el-input {
							// width: 118px;
						}

						/deep/ .el-input--mini .el-input__inner {
							height: 26px;
						}

						/deep/ .el-date-editor.el-input,
						.el-date-editor.el-input__inner {
							width: 100%;
						}

						border: 1px solid #EBEEF5;
						padding: 12px;

						/deep/ .el-form-item__label {
							display: flex;
							justify-content: start;
							font-size: 12px;
							width: 100%;
						}
					}

					// 第二层主体表单
					.mainForm {
						.input-with-select {
							/deep/ .el-select .el-input {
								width: 108px;
							}
						}

						#optionItem {
							width: 100%;
							height: 100%;
							display: flex;
							font-size: 12px;
							align-items: center;
							text-align: center;
							justify-content: start;

							span {
								display: inline-block;
								width: 68px;
								height: 26px;
								line-height: 26px;
								white-space: nowrap;
								/* 禁止换行 */
								overflow: hidden;
								/* 隐藏溢出内容 */
								text-overflow: ellipsis;
								/* 溢出显示省略号 */
							}
						}

						/deep/ .input-with-select .el-input-group__prepend {
							background-color: #fff;
						}

						/deep/ .el-date-editor.el-input,
						.el-date-editor.el-input__inner {
							width: 100%;
						}

						/deep/ .el-input--mini .el-input__inner {
							height: 26px;
						}

						/deep/ .el-select>.el-input {
							// width: 110px;
						}

						/deep/ .el-form-item__label {
							display: flex;
							justify-content: center;
							font-size: 10px;
							padding: 0;
						}

						padding: 12px;
						margin-top: 8px;
						border: 1px solid #EBEEF5;
					}
				}
			}

			.dialog-footer {
				display: flex;
				justify-content: right;
			}
		}

		.innerModel {
			.innerModel-header {
				display: flex;
				align-items: center;
			}

			.innerModel-table {}
		}

	}
</style>